
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetogoacabservice() {



    const cardData =
    {
        keyword: 'Pune to Goa Cab Service',
        heading: 'Meghana Cab : Pune to Goa Cab Service',
        headingDescription: 'Meghana Cab offers Pune to Goa Cab Service, ensuring a smooth, safe, and enjoyable road trip along one of India’s most scenic routes. Covering approximately 450 kilometers, the journey from Pune to Goa is made comfortable with our fleet of air-conditioned sedans, SUVs, and tempo travellers driven by experienced chauffeurs. Whether you’re heading for a beach holiday, corporate retreat, or family vacation, we provide on-time pickups, clean vehicles, and flexible booking options to suit your needs. With 24/7 customer support and transparent pricing, Meghana Cab guarantees a stress-free and memorable travel experience. Book your Pune to Goa Cab Service today and explore Goa’s beauty with comfort and confidence.',


        top: 'Top Places to Visit in Goa with Meghana Cab',

"topPlaces": [
  {
    "title": "Calangute and Baga Beaches",
    "description": "Calangute and Baga Beaches form the vibrant heart of North Goa’s coastal charm. Calangute, known as the ‘Queen of Beaches,’ welcomes families and leisure travelers with its wide sandy stretches, sun loungers, and beach shacks serving Goan seafood. Baga, on the other hand, comes alive after sunset with its nightlife, music clubs, and candlelit dining spots. Together, they offer water sports like jet skiing, parasailing, and banana rides, making them a paradise for thrill seekers. Whether it’s sipping fresh coconut water at sunrise or dancing under the stars, these twin beaches capture the true spirit of Goa."
  },
  {
    "title": "Old Goa Churches",
    "description": "Old Goa, a UNESCO World Heritage Site, echoes with the legacy of Portuguese architecture and faith. It is home to some of India’s grandest churches, including the Basilica of Bom Jesus, where the mortal remains of St. Francis Xavier are preserved. The Se Cathedral, one of Asia’s largest, stands majestic with its gilded altars and serene courtyards. Visitors can also explore the Church of St. Cajetan and the ruins of St. Augustine’s Tower, which whisper stories of Goa’s glorious colonial past. A walk through Old Goa is a journey through history, devotion, and European artistry blended with Indian soul."
  },
  {
    "title": "Dudhsagar Falls and Mollem National Park",
    "description": "Dudhsagar Falls, meaning ‘Sea of Milk,’ is one of India’s tallest waterfalls, cascading from 310 meters through the lush forests of the Western Ghats. Located within Mollem National Park, it is best visited during the monsoon when the four-tiered falls roar with full force. The journey through the dense jungle, often by jeep or trek, adds adventure to the visit. Nearby, Tambdi Surla Temple—Goa’s oldest temple—stands as a serene spiritual site amidst nature. Together, the falls and park create a breathtaking blend of wilderness, spirituality, and raw natural beauty that defines Goa’s untamed side."
  },
  {
    "title": "Chapora and Fort Aguada",
    "description": "Chapora and Fort Aguada are two of Goa’s most iconic fortresses, each offering a unique window into its maritime history. Chapora Fort, perched on a cliff overlooking Vagator Beach, became famous after the Bollywood film 'Dil Chahta Hai' and offers spellbinding sunset views. Fort Aguada, near SinQ Beach, features a 17th-century lighthouse and panoramic views of the Arabian Sea. It once guarded against Dutch and Maratha invasions. Today, both forts attract photographers, history lovers, and explorers seeking solitude and scenic beauty. Their weathered stone walls and sea breeze create the perfect ambiance for reflection and discovery."
  },
  {
    "title": "Anjuna Beach and Flea Market",
    "description": "Anjuna Beach reflects Goa’s free-spirited essence with its bohemian vibe and youthful energy. Known for its rocky shoreline and lively beach parties, it has been a favorite among backpackers since the 1960s. The Wednesday Flea Market is a colorful carnival of local art, handmade jewelry, and global crafts where travelers can shop, eat, and mingle. Sunset cafés serve live music as waves crash gently nearby. Water sports, yoga retreats, and vibrant nightlife complete the experience. Anjuna is not just a beach—it’s a lifestyle, an artistic expression of Goa’s cultural fusion and eternal rhythm."
  },
  {
    "title": "Panaji and Fontainhas Latin Quarter",
    "description": "Goa’s capital, Panaji (Panjim), is a charming riverside city where Portuguese heritage and modern India coexist gracefully. The Latin Quarter of Fontainhas is a labyrinth of narrow streets lined with colorful Portuguese villas, art galleries, and bakeries serving authentic Goan delights. The Church of Our Lady of the Immaculate Conception dominates the skyline with its iconic white façade and zigzag stairways. Strolling through Fontainhas feels like stepping back in time, with colonial lamps and bougainvillea adorning every corner. Panaji also offers Mandovi River cruises, local markets, and cozy cafés that reflect Goa’s timeless coastal charm."
  },
  {
    "title": "Bondla Wildlife Sanctuary",
    "description": "Bondla Wildlife Sanctuary, located about 50 km from Panaji, is Goa’s smallest yet most family-friendly wildlife reserve. Spanning just 8 square kilometers, it houses a zoo, botanical gardens, and deer parks amidst dense tropical forests. The sanctuary shelters leopards, sambars, bison, and a variety of birds including hornbills and peafowls. Educational nature trails make it ideal for school trips and eco-tourism. Bondla also offers eco-cottages for those who wish to stay overnight amidst nature’s calm. Away from the beaches, it provides a refreshing look at Goa’s ecological diversity and natural serenity."
  },
  {
    "title": "Spice Plantations and Tambdi Surla Temple",
    "description": "Goa’s spice plantations, especially around Ponda, offer visitors a fragrant journey through lush estates growing cardamom, nutmeg, pepper, and cashew. Guided tours teach visitors about organic farming and traditional Goan cuisine. Many estates include traditional meals served on banana leaves and cashew feni tasting sessions. Near these plantations lies the Tambdi Surla Temple, a 12th-century Kadamba-style marvel dedicated to Lord Shiva, surrounded by dense forests. Together, they create an experience that connects spirituality, heritage, and nature. The calm surroundings and sacred aura make this region one of Goa’s most soulful destinations."
  },
  {
    "title": "Dona Paula Viewpoint",
    "description": "Dona Paula is a romantic seaside point where the Mandovi and Zuari rivers meet the Arabian Sea. Named after the Portuguese noblewoman Dona Paula de Menezes, it is steeped in legend and love stories. The site features a scenic jetty, whitewashed statues, and breathtaking ocean views. It’s a favorite for sunset photography and leisurely walks. Water sports like kayaking and parasailing are popular here, along with local stalls selling seashell jewelry and street food. Just minutes from Panaji, Dona Paula combines myth, beauty, and serenity, offering travelers a glimpse into Goa’s poetic soul."
  },
  {
    "title": "Goa Carnival and Cultural Festivals",
    "description": "Goa’s Carnival, celebrated every February before Lent, is one of India’s most exuberant festivals, reflecting the state’s Portuguese heritage and joyful spirit. Streets come alive with parades, samba dancers, colorful floats, and lively music. Locals and tourists dance, sing, and feast together during this four-day celebration. Beyond the Carnival, Goa also hosts the Shigmo Festival, Sunburn Music Festival, and Feast of St. Francis Xavier, each showcasing different facets of its diverse culture. These celebrations combine faith, fun, and fusion, turning Goa into a year-round destination for travelers seeking vibrant cultural experiences."
  }
],

      "services": [
    {
      "name": "Pune to Goa Cabs",
      "description": "Travel comfortably from Pune to Goa with Meghana Cab’s reliable Pune to Goa cabs. Whether you’re heading for a beach vacation, a corporate trip, or a family getaway, our fleet of well-maintained vehicles ensures a smooth, safe journey. Choose from hatchbacks, sedans, SUVs, and premium cars like Innova Crysta, all equipped with air conditioning and driven by professional chauffeurs familiar with the best routes. Enjoy timely pickups, door-to-door service, and transparent pricing for an unforgettable travel experience."
    },
    {
      "name": "Pune to Goa Car Rental",
      "description": "Rent a car from Pune to Goa with Meghana Cab and enjoy complete flexibility during your trip. Our car rental options include budget-friendly hatchbacks, spacious sedans, and luxurious SUVs like the Innova Crysta. Ideal for solo travelers, couples, and groups alike, our vehicles come fully serviced and sanitized. Drive at your own pace or hire a professional driver for a stress-free ride. Book your Pune to Goa car rental today and experience hassle-free intercity travel with excellent customer support."
    },
    {
      "name": "Pune to Goa Taxi Service",
      "description": "Looking for a dependable Pune to Goa taxi service? Meghana Cab offers prompt and efficient taxi services tailored to your travel needs. Our experienced drivers ensure safe and timely journeys, while our fleet is equipped with modern amenities including air conditioning and comfortable seating. Whether you need a one-way trip or a round trip, we provide flexible packages and competitive rates. Choose Meghana Cab for affordable and reliable taxi service from Pune to Goa."
    },
    {
      "name": "Pune to Goa Taxi Fare",
      "description": "Get transparent and competitive taxi fares for your Pune to Goa trip with Meghana Cab. Our fare structure is clear and upfront with no hidden charges, allowing you to plan your travel budget with ease. Prices vary depending on vehicle type, distance, and trip type (one-way or round trip). Whether you select a budget hatchback or a premium Innova Crysta, you can expect great value for your money. Contact us for a customized fare quote based on your exact travel dates and requirements."
    },
    {
      "name": "Pune to Goa Cab Packages",
      "description": "Explore various Pune to Goa cab packages offered by Meghana Cab designed to suit different traveler profiles. Choose from economical packages for budget travelers, luxury packages with Innova Crysta and other SUVs for comfort seekers, or custom packages for business trips and sightseeing tours. Our packages include flexible pickup and drop points, round-trip options, and 24/7 customer support. Travel with peace of mind knowing you have a reliable cab partner for your Goa trip."
    },
    {
      "name": "Best Cab Service from Pune to Goa",
      "description": "Experience the best cab service from Pune to Goa with Meghana Cab. Renowned for punctuality, professionalism, and customer satisfaction, we provide high-quality vehicles and experienced drivers to make your journey memorable. From comfortable seating to hassle-free online booking and real-time ride tracking, every aspect of our service is designed for your convenience. Whether it’s a solo trip or a group holiday, trust Meghana Cab to deliver excellence on the road."
    },
    {
      "name": "Pune to Goa Innova Crysta Rental",
      "description": "Travel in style with Meghana Cab’s Pune to Goa Innova Crysta rental service. The Innova Crysta is perfect for families and groups looking for spacious, luxurious, and comfortable rides. Equipped with premium features like powerful AC, ample legroom, and advanced safety options, our Innova Crysta cabs make long-distance travel enjoyable. Hire with or without a professional driver and enjoy a smooth journey from Pune to Goa. Book your Innova Crysta rental now for a superior travel experience."
    },
    {
      "name": "Pune to Goa One Way Taxi",
      "description": "Need a hassle-free one-way taxi from Pune to Goa? Meghana Cab offers convenient one-way taxi services with flexible drop locations across Goa. Ideal for travelers who prefer point-to-point travel without return commitments, our one-way cabs come in various vehicle categories including sedans, SUVs, and premium Innova Crysta cars. Enjoy door-to-door pickups, professional drivers, and transparent pricing. Book your Pune to Goa one-way taxi now and travel on your schedule."
    }
  ],
  "tableData": [
    ["Pune to Goa Cabs", "Pune to Goa Car Rental"],
    ["Pune to Goa Taxi Service", "Pune to Goa Taxi Fare"],
    ["Pune to Goa Cab Packages", "Best Cab Service from Pune to Goa"],
    ["Pune to Goa Innova Crysta Rental", "Pune to Goa One Way Taxi"],
    ["", ""]
  ],











"whychoose": [
    {
        "WhyChooseheading": "Reliable Pune to Goa Cab Service",
        "WhyChoosedescription": "Meghana Cab offers dependable and comfortable cab services from Pune to Goa, perfect for leisure trips, business travel, or family vacations."
    },
    {
        "WhyChooseheading": "Timely Pick-Up and Drop Across Goa",
        "WhyChoosedescription": "We ensure punctual pick-ups from Pune and drop-offs at any Goa destination, including Panaji, Calangute, Baga, and more, so you reach your spot on time."
    },
    {
        "WhyChooseheading": "Experienced Drivers for Long-Distance Travel",
        "WhyChoosedescription": "Our skilled drivers are familiar with the Pune to Goa route, ensuring a safe, smooth, and comfortable journey."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Enjoy competitive Pune to Goa cab fares with clear pricing and no hidden costs, making your travel budget-friendly and stress-free."
    },
    {
        "WhyChooseheading": "Safe and Sanitized Vehicles",
        "WhyChoosedescription": "All our cabs are thoroughly sanitized before every trip and come with essential safety features like GPS tracking and seat belts."
    },
    {
        "WhyChooseheading": "24/7 Availability for Pune to Goa Travel",
        "WhyChoosedescription": "Whether you need an early morning departure or a late-night ride, Meghana Cab is available round the clock to serve your Pune to Goa travel needs."
    },
    {
        "WhyChooseheading": "Customizable Trip Packages",
        "WhyChoosedescription": "Choose from one-way, round-trip, or multi-stop journey options tailored to your Goa travel plans and convenience."
    },
    {
        "WhyChooseheading": "Easy Online Booking and Customer Support",
        "WhyChoosedescription": "Book your Pune to Goa cab quickly via our website or app, with dedicated customer support to assist you at every step."
    }
]























    }

// ✅ FAQ and Testimonials for Pune to Goa Cab Service – Meghana Cab

const faqData = [
    {
        question: "How can I book a Pune to Goa cab with Meghana Cab?",
        answer: "You can book a Pune to Goa cab easily through Meghana Cab’s website or by calling our customer service at +91 9075462128."
    },
    {
        question: "What cab options are available for travel from Pune to Goa?",
        answer: "Meghana Cab offers hatchbacks, sedans, SUVs, and tempo travellers for Pune to Goa trips, depending on your group size and comfort preference."
    },
    {
        question: "Is one-way cab service available from Pune to Goa?",
        answer: "Yes, we offer both one-way and round-trip cab services from Pune to various destinations in Goa."
    },
    {
        question: "How long does it take to travel from Pune to Goa by cab?",
        answer: "The journey from Pune to Goa typically takes around 9 to 12 hours, depending on traffic and the route chosen."
    },
    {
        question: "Are tolls and taxes included in the cab fare for Pune to Goa?",
        answer: "Tolls, state taxes, and parking charges are additional and are clearly communicated during the booking process."
    },
    {
        question: "Are Meghana Cab drivers experienced for long-distance travel like Pune to Goa?",
        answer: "Yes, our drivers are experienced, professional, and well-acquainted with long-distance routes including Pune to Goa."
    },
    {
        question: "Can I request breaks or custom stops during the Pune to Goa journey?",
        answer: "Yes, you can request halts or breaks during the trip. Just let us know your requirements while booking."
    },
    {
        question: "Is the cab service from Pune to Goa available at night?",
        answer: "Yes, Meghana Cab provides 24/7 service, so you can book a cab for day or night travel as per your convenience."
    },
    {
        question: "What payment options are accepted for Pune to Goa cab bookings?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash for all bookings."
    },
    {
        question: "How do I contact Meghana Cab to book a Pune to Goa cab?",
        answer: "You can contact Meghana Cab at +91 9075462128 for bookings and support."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Nilesh Naik',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Meghana Cab made our Pune to Goa trip extremely comfortable. The car was clean, and the driver knew the route well. A hassle-free experience!”',
    },
    {
        name: 'Ms. Riya Deshpande',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“I highly recommend Meghana Cab for Pune to Goa travel. On-time pickup, smooth ride, and the support team was very responsive.”',
    },
];










































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];








const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Goa Cab Service",
  "description": "Experience a smooth and enjoyable Pune to Goa cab service with Meghana Cabs. Affordable taxi fares, comfortable rides, and reliable car rentals for one-way or round trips. Perfect for vacations, corporate travel, or family getaways.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "6932"
  }
};





    return (
        <div>



<Helmet>
  <title>Pune to Goa Cab Service | Affordable Taxi & Car Rental @ Meghana Cabs</title>
  <meta
    name="description"
    content="Book Pune to Goa cab service with Meghana Cabs. Affordable and comfortable Pune to Goa taxis, car rentals, and one-way cabs. Reliable service and best fares for a safe, smooth journey."
  />
  <meta
    name="keywords"
    content="pune to goa cabs, Pune to goa car rental, Pune to goa taxi, Pune to goa taxi fare, Pune to goa cab price, Pune to goa cab package, Best cab service from pune to goa, Cab service from pune to goa, Car hire pune to goa, Pune goa cab service, Pune to goa cab booking, pune to goa cab charges, Pune to goa cab cost, Pune to goa cab rental, pune to goa cab service fare, Pune to goa cab service rates, pune to goa car booking, pune to goa car hire, pune to goa car rental price, pune to goa innova rental, pune to goa one way cab, pune to goa one way taxi, pune to goa private cab, pune to goa taxi fare one way, pune to goa taxi packages, pune to goa taxi price, pune to goa taxi service, pune to goa innova rental, pune to goa innova Cabs, pune to goa innova crysta cab, pune to goa innova cab package"
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/61.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetogoacabservice;